import AppRoutes from "./routes/appRoute";

function App() {
  return <AppRoutes />;
}

export default App;